import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";

import { BaseService } from "./base.service";
import { IColourPalette } from "../interfaces/icolourpalette";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";

/**
 * @whatItDoes Service for retrieving anything colour palette related
 *
 * @howToUse Inject service in to use
 */
@Injectable()
export class ColourPaletteService extends BaseService {
    /**
     * Service constructor
     * @param httpClient angular http module
     * @param toastr toast manager
     * @param store store
     */
    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    /**
     * Returns an observable list of colour palettes
     */
    getAll(): Observable<IColourPalette[]> {
        return super.get("/api/ColourPalette").pipe(
            map((res: any) => res as IColourPalette[])
        );
    }
}




